export const SPONSORED_PRIZES = "SPONSORED_PRIZES";

export const SponsoredPrizeCompetition = {
  id: SPONSORED_PRIZES,
  title: "Your Sponsored Prizes",
  iteration: {
    id: SPONSORED_PRIZES,
    parentId: SPONSORED_PRIZES,
    description:
      "Enter towards these prizes by achieving safe driving scores! These prizes are hosted by teams you have joined (such as from your emplyer, an organization, or other host.)",
  },
};

export const SponsoredPrizeBanners = {
  challengeBanners: {
    desktopMain: "images/banners/Dashboard-Main-Desktop.webp",
    tabletMain: "images/banners/Dashboard-Main-Tablet.webp",
    mobileMain: "images/banners/Dashboard-Main-Mobile.webp",
  },
};

export const InfoModalButtonOptions = (dialogInfo) => [
  {
    button: "Challenge Details",
    ...dialogInfo.comp,
  },
  {
    button: "Grand Prize Details",
    ...dialogInfo.prize,
  },
];
